//@ts-nocheck
import React, { useState } from "react";
import { Autocomplete, Chip, Checkbox, TextField, FormControlLabel, IconButton, Tooltip, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "../../../../components/MDInput";
import MDDatePicker from "../../../../components/MDDatePicker";
import { FilterAltOff } from "@mui/icons-material";

interface FilterToolbarProps {
  options: any[];
  selectedOptions: any[];
  onSelectionChange: (newSelection: string[]) => void;
  onFilterChange: (filters: { debit: boolean; credit: boolean }) => void;
  onClearFilters:() => void;
}

const TransactionsFilterToolbar: React.FC<FilterToolbarProps> = ({ onFilterChange, filters , onClearFilters }) => {
  return (
    <MDBox display="flex" alignItems={"center"} gap={4} marginLeft={7} width={"100%"}>
      <MDBox display="flex" flexDirection="row" justifyContent="space-between" gap={2}>
        <MDBox display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox checked={filters.debit} onChange={(e) => onFilterChange(e, "debit")} />
            }
            label={<MDTypography fontSize="0.875rem">Debit</MDTypography>}
            sx={{ whiteSpace: "nowrap", marginRight: 0, display: "flex", alignItems: "center" }}
          />
        </MDBox>
        <MDBox display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox checked={filters.credit} onChange={(e) => onFilterChange(e, "credit")} />
            }
            label={<MDTypography fontSize="0.875rem">Credit</MDTypography>}
            sx={{ whiteSpace: "nowrap", marginRight: 0, display: "flex", alignItems: "center" }}
          />
        </MDBox>

        {onClearFilters && (
          <Tooltip title="Reset All Filters" arrow>
            <IconButton
              size="medium"
              onClick={onClearFilters}
              sx={{
                width: 25,
                height: 40,
                borderRadius: "6px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon sx={{ fontSize: 32, color: "#6B7280" }}>filter_alt_off</Icon>
            </IconButton>
          </Tooltip>
        )}
      </MDBox>
    </MDBox>
  );
};

export default TransactionsFilterToolbar;
